import { styled } from "styled-components";
import { device } from "../../styles/style";

export const BackButton = styled.a`
  position: fixed;
  left: 30px;
  top: 150px;
  color: var(--mainTextColor);
  cursor: pointer;
  transition: 500ms;

  &:hover {
    text-shadow: 0 0 3px var(--mainTextColorOpacity);
  }
  &:visited {
    color: var(--mainTextColor);
  }

  @media ${device.mobileS} and ${device.tablet} {
    width: 40px;
    height: 20px;
    font-size: 0.5rem;
    left: auto;
    right: 20px;
    top: 60px;
  }
`;
